import { render, staticRenderFns } from "./Epis.vue?vue&type=template&id=0889da6d&scoped=true"
import script from "./Epis.vue?vue&type=script&lang=js"
export * from "./Epis.vue?vue&type=script&lang=js"
import style0 from "./Epis.vue?vue&type=style&index=0&id=0889da6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889da6d",
  null
  
)

export default component.exports